<template>
  <div
      :id="`appointments_list_${currentTime}`"
      class="card_list appointments relative" :class="noti ? 'scroll_unset' : ''"
  >
    <div class="contents_title">
      <h3>{{ $t('unit.today') }}
        <span>{{ displayScheduleList.length }} {{ $t('appointment.patient_waiting') }}</span>
        &nbsp;|&nbsp;
        <div style="float: right; margin-top: 8px; margin-left: 8px;">
          <button
              class="listBtn"
              @click="(event)=>{handleDataTypeClick(event, false)}"
          >
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
              <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M4.00629 11H9.99371C10.5472 11 11 10.5472 11 9.99371V4.00629C11 3.45283 10.5472 3 9.99371 3H4.00629C3.45283 3 3 3.45283 3 4.00629V9.99371C3 10.5472 3.45283 11 4.00629 11ZM8.98742 8.98742H5.01258V5.01258H8.98742V8.98742ZM14.0063 11H19.9937C20.5472 11 21 10.5472 21 9.99371V4.00629C21 3.45283 20.5472 3 19.9937 3H14.0063C13.4528 3 13 3.45283 13 4.00629V9.99371C13 10.5472 13.4528 11 14.0063 11ZM18.9874 8.98742H15.0126V5.01258H18.9874V8.98742ZM9.99371 21H4.00629C3.45283 21 3 20.5472 3 19.9937V14.0063C3 13.4528 3.45283 13 4.00629 13H9.99371C10.5472 13 11 13.4528 11 14.0063V19.9937C11 20.5472 10.5472 21 9.99371 21ZM5.01258 18.9874H8.98742V15.0126H5.01258V18.9874ZM14.0063 21H19.9937C20.5472 21 21 20.5472 21 19.9937V14.0063C21 13.4528 20.5472 13 19.9937 13H14.0063C13.4528 13 13 13.4528 13 14.0063V19.9937C13 20.5472 13.4528 21 14.0063 21ZM18.9874 18.9874H15.0126V15.0126H18.9874V18.9874Z"
                  :fill="!list ? '#2A589F' : '#3B3A39'"
              />
            </svg>
          </button>
        </div>
        <div style="float: right; margin-top: 8px;">
          <button
              class="listBtn"
              @click="(event)=>{handleDataTypeClick(event, true)}"
          >
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
              <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M5 8.4469H19C19.55 8.4469 20 8.00885 20 7.47345C20 6.93805 19.55 6.5 19 6.5H5C4.45 6.5 4 6.93805 4 7.47345C4 8.00885 4.45 8.4469 5 8.4469ZM19 11.0265H5C4.45 11.0265 4 11.4646 4 12C4 12.5354 4.45 12.9735 5 12.9735H19C19.55 12.9735 20 12.5354 20 12C20 11.4646 19.56 11.0265 19 11.0265ZM5 15.5531H19C19.56 15.5531 20 15.9911 20 16.5265C20 17.0619 19.55 17.5 19 17.5H5C4.45 17.5 4 17.0619 4 16.5265C4 15.9911 4.45 15.5531 5 15.5531Z"
                  :fill="list ? '#2A589F' : '#3B3A39'"
              />
            </svg>
          </button>
        </div>
      </h3>
      <div style="float: right;">
        <a
            class="patient_add pointer no-drag"
            style="display: inline-block;color: var(--blue70);font-size: 13px;font-weight: 700;margin-top: 10px;margin-right:5px;padding: 10px;border: 2px var(--blue70) solid;border-radius:5px;"
            @click="handleAddClick"
        >
          <img src="@/assets/images/svg/icon_addpatient_schedule.svg" width="18" height="17" alt=""/>
          &nbsp;&nbsp;{{ $t('RMC.add') }}
        </a>
        <a
            class="patient_add pointer no-drag"
            @click="$modal.show('patient-append-modal')"
            style="display: inline-block;color: var(--blue70);font-size: 13px;font-weight: 700;margin-top: 10px;padding: 10px;border: 2px var(--blue70) solid;border-radius:5px;"
        >
          <img src="../../../assets/images/member.png" alt="member"
               style="width: 18px;margin-right: 6px;"
          >
          {{ $t('patients.add.btn') }}
        </a>
      </div>
    </div>
    <div class="box" v-if="!list">
      <ul class="patient_list" v-if="scheduleList.length > 0" ref="patientListUl">
        <li v-for="item in displayScheduleList" :key="item.schedule.seqSchedule"
            class="pointer patient_list_li"
            @click="clickUser(item.patient.seqPatient)"
        >
          <div class="patient_list_head">
            <div class="list_patient_info">
              <span
                  class="appointments_time">
                {{
                  moment(item.schedule.scheduleExpectStartDatetime).format('hh:mm a')
                }}
              </span>
              <p>{{ item.patient.patientInfo.patientInfoName }}</p>
            </div>
            <div
                class="online_visit_btn"
            >
              <img class="online_visit_on"
                   v-show="scheduleStatus(item.schedule.scheduleExpectStartDatetime)"
                   src="/images/ic/etc/ic-videocam-on.svg"
                   alt=""
                   v-on:click.stop.prevent
                   v-on:click="startRmc(item.schedule, item.patient.check)"
              />
              <img class="online_visit_off" v-show="!scheduleStatus(item.schedule.scheduleExpectStartDatetime)"
                   src="/images/ic/etc/ic-videocam-off.svg"
                   alt=""
                   v-on:click.stop.prevent
              />
            </div>
          </div>
          <dl class="patient_sub_info">
            <dt>{{ $t('patient.info.gender.key') }}</dt>
            <dd>{{ computedGender(item.patient.patientInfo.patientInfoGender) }}</dd>
            <dt>{{ $t('patient.info.date_of_birth') }}</dt>
            <dd>{{
                item.patient.patientInfo.patientInfoBirth ?
                    moment(item.patient.patientInfo.patientInfoBirth).locale($t('country')).format('ll') : '-'
              }}
            </dd>
            <dt>{{ $t('patient.condition.on_set_date') }}</dt>
            <dd>{{
                item.patient.patientInfo.patientInfoOccurrenceDate ?
                    moment(item.patient.patientInfo.patientInfoOccurrenceDate).locale($t('country')).format('ll')
                    : '-'
              }}
            </dd>
            <dt>{{ $t('patient.condition.brain_lesions') }}</dt>
            <dd>{{ item.patient.patientInfo.patientInfoBrainLesion || '-' }}</dd>
            <dt>S.D</dt>
            <dd>{{
                item.patient.patientInfo.patientInfoOccurrenceDate ? moment().diff(
                    item.patient.patientInfo.patientInfoOccurrenceDate, "days") + $t('unit.days') : '-'
              }}
            </dd>
            <dt>mRS</dt>
            <dd>{{ item.patient.patientStatus.patientStatusMRS || '-' }}</dd>
          </dl>
        </li>
      </ul>
      <AppointmentsNoData
          v-else
          class="patient_list no_data"
          :title="loading ? $t('table.list.loading') : $t('patients.no_appointments')"
      />
    </div>
    <div v-else>
      <ListTable
          class="patient_list"
          v-if="scheduleList.length > 0"
          :data="displayScheduleList"
      >
      </ListTable>
      <AppointmentsNoData
          v-else
          class="patient_list no_data"
          :title="loading ? $t('table.list.loading') : $t('patients.no_appointments')"
      />
    </div>
    <ScheduleEditModal
        @getMySchedule="getMySchedule"
    />
    <NotificationModal
        @hideNoti="hideNoti"
        @showNoti="showNoti"
    />
  </div>
</template>

<script>
import _API from '../../../api';
import ScheduleEditModal from '../../modal/scheduleCalendar/scheduleEdit'
import {mapActions, mapGetters} from 'vuex';
import ListTable from './listTable'
import {GENDER_TRANS} from "@/enum/lib";

export default {
  data() {
    return {
      noti: false,
      patientList: [],
      scheduleList: [],
      sortedScheduleList: [],
      beforeAppointment: -15, // 15분 전
      currentTime: this.moment(),
      createTime: this.moment(),
      intervalId: '',
      refreshTime: 1000 * 60, // 1분 마다
      list: !this.getDeviceBrowser().notNewWindow,
      loading: false,
    }
  },
  components: {
    ScheduleEditModal,
    ListTable,
    AppointmentsNoData: () => import('./noItem'),
    NotificationModal: () => import('@/components/modal/notification'),
  },
  methods: {
    ...mapActions(['inspectSelectPatient', 'refreshScheduleForToday']),
    ...mapGetters(['getDeviceBrowser']),
    /**
     * 환자 목록 중 오늘 스케쥴 예약자와 일치하는 사람만 분류한다.
     */
    sortScheduleList() {
      try {
        this.sortedScheduleList = this.scheduleList.map((schedule => {
          return {
            schedule, patient: this.patientList.filter(patient => {
              return schedule.seqMedicalRelation === patient.patientInfo.seqMedicalRelation;
            })[0]
          };
        }));
      } catch (e) {
        throw new Error(`[drawPatientList]${e}`);
      }
    },
    /**
     * 마운트상태에서 환자목록/스케쥴을 조회한다.
     * @returns {Promise<void>}
     */
    async getPatientListAndScheduleForMountStatus() {
      try {
        await this.getPatientsAndSchedules();
        await this.sortScheduleList();
      } catch (e) {
        throw new Error(`[getPatientListAndScheduleForMountStatus]${e}`);
      }
    },
    /**
     * 환자리스트와 스케쥴을 불러온다.
     * @returns {Promise<unknown>}
     */
    getPatientsAndSchedules() {
      return new Promise((resolve, reject) => {
        this.loading = true;
        _API.PATIENT_LIST.getMyPatientsAndReservedSchedulesForToday()
            .then(res => {
              if (res.data.isSuccess && res.data.failedCode === '0') {
                try {
                  this.$store.dispatch(`initPatientListAndScheduleList`, {
                    patientList: res.data.patientList, scheduleList: res.data.scheduleList
                  }).then(_ => {
                    this.patientList = res.data.patientList;
                    this.scheduleList = res.data.scheduleList;
                    resolve();
                  })
                } catch (e) {
                  reject(`[getPatientsAndSchedules]${e}`);
                }
              } else {
                this.$modal.show('common-alert-modal', {
                  messageType: 'short',
                  message: 'alert.unexpected_error'
                });
                resolve();
              }
            })
            .catch(e => reject(`[getPatientsAndSchedules]${e}`))
            .finally(() => {
              this.loading = false;
            })
      });
    },
    /**
     * seqPatient 를 이용해 화면을 환자 상세페이지로 전환한다.
     * @param seqPatient
     */
    clickUser(seqPatient) {
      this.inspectSelectPatient(seqPatient);
      this.$router.push(`/patientList/details/home?id=${seqPatient}`);
    },
    /**
     * 카운팅 하는 interval 함수를 삭제한다.
     */
    killCountSecond() {
      clearInterval(this.intervalId)
    },
    /**
     * 카운팅하는 setInterval 함수를 시작한다.
     */
    countSecond() {
      this.intervalId = setInterval(() => {
        this.currentTime = this.moment();
      }, this.refreshTime);
    },
    /**
     * 원격상담 화면을 연다.
     * @param selectedSchedule
     */
    startRmc(selectedSchedule, check) {
      if (check) {
        if (this.$store.getters.getVideoCallOpen) {
          this.$modal.show('common-alert-modal', {
            messageType: 'short',
            message: 'alert.already_in_progress'
          });
          return
        }
        // isMobile  여부에 따라 페이지 이동 여부 분기 처리
        if (this.getDeviceBrowser().notNewWindow) {
          this.$router.push('/remote');
        }

        this.$store.dispatch('toggleRemoteModal', {open: true, selectedSchedule: selectedSchedule});
      } else {
        // TODO: 불가 팝업
      }
    },
    /**
     * fcm token 을 업데이트 한다.
     * @param token
     * @returns {Promise<unknown>}
     */
    updateFcmToken(token) {
      return new Promise((resolve) => {
        _API.USER.updateFcmToken(token)
            .then(({data}) => {
              if (data.isSuccess) {
                localStorage.setItem('fcmToken', token);
              }
              resolve();
            })
      });
    },
    hideNoti() {
      this.noti = false;
    },
    showNoti() {
      this.noti = true;
    },
    handleDataTypeClick(_event, value) {
      this.list = value;
    },
    handleAddClick() {
      this.$modal.show('schedule-edit-modal', 'write');
    },
    getMySchedule() {
      this.refreshScheduleForToday(true);
    },
  },
  computed: {
    displayScheduleList() {
      return this.sortedScheduleList;
    },
    scheduleStatus() {
      return (scheduleExpectStartDatetime) => {
        const appointment = this.moment(scheduleExpectStartDatetime).format('YYYY-MM-DD HH:mm');
        const diff = this.moment.duration(this.moment(this.currentTime).diff(appointment)).asMinutes();

        return Math.floor(diff) >= this.beforeAppointment;
      };
    },
    computedGender() {
      return (patientInfoGender) => {
        return patientInfoGender ? this.$t(GENDER_TRANS[patientInfoGender].trans) : this.$t(GENDER_TRANS[null].trans)
      }
    },
  },
  watch: {
    sortedScheduleList: {
      deep: true,
      handler() {
        if (this.sortedScheduleList.length >= 0) {
          this.killCountSecond();
          this.countSecond();
        } else {
          this.killCountSecond();
        }
      }
    },
    currentTime: {
      deep: true,
      handler() {
        const diff = this.moment.duration(this.moment(this.currentTime).diff(this.createTime)).asMinutes();

        if (diff >= 5) {
          this.createTime = this.moment();
          this.refreshScheduleForToday(true);
        }
      }
    },
  },
  mounted() {
    this.$store.dispatch('changeNavMenu', 0);
    this.$store.dispatch('changeMainMenu', 0);

    this.getPatientListAndScheduleForMountStatus()
        .catch(e => console.error(`[mounted]${e}`));

    if (this.$fbConf.isSupported) {
      Notification.requestPermission()
          .then((permission) => {
            if (permission === "granted") {
              this.$fbConf.GET_FCM_TOKEN()
                  .then(newToken => {
                    const oldToken = localStorage.getItem('fcmToken');
                    if (oldToken !== newToken) {
                      this.updateFcmToken(newToken);
                    }
                  })
            } else {
              localStorage.setItem('fcmToken', '');
            }
          })
          .catch(e => {
            console.log('[Notification.requestPermission]', e);
          });
    }
  },
  created() {
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if ((mutation.type === 'refreshScheduleForToday') && state.refreshSchedule) {
        if (state.mainMenu === 0)
          this.getPatientListAndScheduleForMountStatus()
              .then(() => this.refreshScheduleForToday(false))
      }
    });
  },
  destroyed() {
    this.killCountSecond();
  },
  beforeDestroy(){
    this.killCountSecond();
    this.unsubscribe();
  },
}
</script>
<style lang="scss">
.appointments {
  .patient_list li .patient_list_head .list_patient_info {
    width: 255px;
    @media screen and (max-width: 1024px) {
      width: 210px;
    }

    p {
      width: 255px;
      @media screen and (max-width: 1024px) {
        width: 210px;
      }
    }
  }

  .appointments_time {
    font-size: 18px;
    color: var(--blue70);
    font-weight: 700;
    text-transform: uppercase;
  }

  .online_visit_btn {
    display: flex;
    justify-content: flex-end;

    .online_visit_off {
      cursor: initial;
    }

    .online_visit_on {
    }
  }
}

@media screen and (min-width: 320px) and (max-width: 430px) {
  .appointments {
    padding-top: 20px;
    padding-left: 20px;

    .contents_title {
      margin-bottom: 20px;
    }

    .box {
      .patient_list {
        height: calc(var(--app-height) - 210px);
      }

      .patient_list {
        width: calc(100vw - 20px);
        left: calc(var(--app-scroll) + 20px);
        position: sticky;

        .patient_list_li {
          width: calc(100vw - 40px);
          margin-left: 0;
          margin-right: 0;

          .patient_sub_info {
            dt {
              width: 120px;
            }

            dd {
              width: calc(100% - 120px);
            }
          }
        }
      }
    }
  }
}

.listBtn {
  border-width: 0;
  background-color: unset;
  padding: 0;
  cursor: pointer;
  width: 24px;
  height: 24px;

  svg {
    display: block;
    margin: auto;
  }
}
</style>

